import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpServiceParent } from './httpServiceParent';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PhobosTaskInstance } from '../domain/phobos-task-instance';
import { PropertyStoreService } from './stores/property-store.service';

@Injectable({
   providedIn: 'root'
})
export class SearchService extends HttpServiceParent {
   constructor(
      private http: HttpClient,
      private propertyStore: PropertyStoreService
   ) {
      super(propertyStore);
   }

   getTasksBySearchTerm(
      searchTerm: string,
      propId: number
   ): Observable<PhobosTaskInstance[]> {
      return this.http.get<PhobosTaskInstance[]>(
         `${environment.apiEndpoint}/search`,
         {
            params: {
               propertyId: encodeURIComponent(propId),
               searchTerm: encodeURIComponent(searchTerm)
            }
         }
      );
   }
}
